Application.Bubbles = {
    ui: {
        container: '.js-bubbles',
        next: '.js-form__next',
        back: '.js-form__back',
        aside: '.js-bubbles__aside',
        open: '.js-bubbles__open',
        close: '.js-bubbles__close',
        detail: '.js-bubbles__detail'
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // open
        $(document).on('click', this.ui.open, function(e){
            e.preventDefault();
            self.open($(this).attr('data-id'));
        });
        // auto-open first
        $(this.ui.open).eq(0).click();

        // close
        $(document).on('click', this.ui.close, function(e){
            e.preventDefault();
            self.close();
        });

        // actions
        $(this.ui.back).add(this.ui.next).click(function(e){
            self.showLoader();
        });

    },
    open: function(id){

        $(this.ui.open).removeClass('active').filter('[data-id="' + id + '"]').addClass('active');
        $(this.ui.aside).addClass('active');
        $(this.ui.detail).removeClass('active').filter('[data-id="' + id + '"]').addClass('active');

    },
    close: function () {

        $(this.ui.open).removeClass('active');
        $(this.ui.aside).removeClass('active');

    },
    showLoader: function(){

        $('body').addClass('loading');

    }
};